export const classes = {
  wrapper:
    'flex w-[18rem] bg-white p-4 rounded-lg cursor-pointer hover:bg-grey-2 transition-all shadow-card border border-grey-2 dark:bg-[#332e43] dark:hover:bg-white/[0.06] dark:border-white/10',
  aiBadge: 'ml-2 bg-grey-2 text-grey-7 dark:bg-white/[0.06] dark:text-mauve-2',
  titleWrapper: 'flex flex-col items-start justify-start h-full ml-3',
  title:
    'text-grey-8 dark:text-mauve-1 font-semibold leading-none flex items-center mb-1',
  titleSm: 'text-xs',
  titleBase: 'text-base',
  description: 'font-normal text-sm text-grey-7 dark:text-mauve-2',

  condensedWrapper:
    'group relative flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-black/10 bg-white/[0.78] shadow-aurora-card transition-shadow hover:shadow-[0_12px_26px_-16px_rgba(60,50,60,0.26)] dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  imageWrapper: 'relative aspect-[16/9] overflow-hidden',
  image: 'size-full object-contain',
  placeholder: 'place-center size-full',
  placeholderIcon: 'size-8 shrink-0',
  placeholderIconWrapper: 'size-10 text-taupe-1 dark:text-mauve-3',
  aiMark: 'absolute left-2.5 top-1.5 flex text-[rgb(88,110,115)]',
  condensedTitle:
    'truncate px-2 pb-2 pt-1 text-center text-xs font-semibold text-taupe-3 dark:text-mauve-1',
  infoWrapper:
    'absolute right-1.5 top-1.5 flex opacity-0 transition-opacity group-hover:opacity-100',
  infoIcon: 'text-taupe-3 dark:text-mauve-1',
};
